import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';

import { LiveTileStore } from '../../live-tiles/live-tile.store';
import { LiveTileViewService } from '../../live-tiles/live-tile-view.service';
import { APP_CONFIG, type AppConfig } from '../config/app-config.model';
import {
  provideRealtimeTelemetry,
} from './application-insights-realtime-telemetry';
import {
  AccessTokenProvider,
  provideAccessTokenProvider,
} from './access-token.provider';
import {
  RealtimeConnectionFactory,
  SignalRRealtimeConnectionFactory,
} from './realtime-connection.factory';
import {
  GeneratedRealtimeGrantClient,
  RealtimeGrantClient,
} from './realtime-grant.client';
import { RealtimeRetryPolicy } from './realtime-retry.policy';
import { RealtimeStatusService } from './realtime-status.service';
import { RealtimeSubscriberService } from './realtime-subscriber.service';

export function provideRealtime(): EnvironmentProviders {
  return makeEnvironmentProviders([
    LiveTileStore,
    LiveTileViewService,
    RealtimeSubscriberService,
    RealtimeStatusService,
    RealtimeRetryPolicy,
    provideRealtimeTelemetry(),
    provideAccessTokenProvider(),
    { provide: RealtimeConnectionFactory, useClass: SignalRRealtimeConnectionFactory },
    {
      provide: RealtimeGrantClient,
      useFactory: (config: AppConfig, tokenProvider: AccessTokenProvider) =>
        new GeneratedRealtimeGrantClient(config.signalRUrl, tokenProvider),
      deps: [APP_CONFIG, AccessTokenProvider],
    },
  ]);
}